import { useEffect } from 'react';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useDevices } from '../providers/DevicesProvider';

/**
 * Hook that ensures Chime SDK device lists are refreshed when our custom device provider detects new devices
 */
export function useDeviceRefresh() {
  const meetingManager = useMeetingManager();
  const { audioInputDevices, audioOutputDevices, videoInputDevices } = useDevices();

  useEffect(() => {
    // When our device lists change, refresh the Chime SDK device lists
    const refreshChimeDevices = async () => {
      try {
        // Force Chime SDK to refresh its device lists
        await meetingManager.listAudioInputDevices();
        await meetingManager.listAudioOutputDevices();
        await meetingManager.listVideoInputDevices();
        
        console.log('Chime SDK device lists refreshed');
      } catch (error) {
        console.warn('Failed to refresh Chime SDK device lists:', error);
      }
    };

    refreshChimeDevices();
  }, [audioInputDevices.length, audioOutputDevices.length, videoInputDevices.length, meetingManager]);
}
